export default function dialNumber(number) {
	globalThis.location.assign(`tel:${number}`);
}
